import Component from '../abstracts/Component';

export default class WishlistComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-wishlist',
      remove: '.js-remove-wish',
      qtyWishlistTitle: '.wishlistCount-title',
      wishlistCount: '[data-wishlist-count]',
      wishlistCountMobile: '[data-wishlist-count-mobile]',
    };
  }

  get CLASSES() {
    return {
      removing: 'removing',
    };
  }

  constructor() {
    super();

    this.main = $(this.SELECTORS.main);
    this.remove = $(this.SELECTORS.remove);
    this.qtyWishlistTitle = $(this.SELECTORS.qtyWishlistTitle);
    this.wishlistCount = document.querySelector(this.SELECTORS.wishlistCount);
    this.wishlistCountMobile = document.querySelector(this.SELECTORS.wishlistCountMobile);
  }

  appendHtml(html) {
    return new Promise((resolve, reject) => {
      try {
        this.main.html(html);
        resolve();
      } catch(e) {
        reject(e);
      }
    });
  }

  updateWishlist() {
    let self = this;
    let $elem = self.main;

    return $.ajax({
      url:  $elem.data('href'),
      dataType: "html",
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }


  removeProduct(el) {
    let self = this;
    let $elem = $(el);
    let url = $elem.data('href');

    $.ajax({
      url:  url,
      dataType: "json",
      type: 'POST',
      success: function() {
        self.$emit(self.$customEvents.PRODUCT_EVENTS.removedfromwish, el);
      },
      error: function(xhr) {
        console.log(xhr);
      }
    });
  }

  updateQtyWishlist() {
    let qtyNew = this.wishlistCount.dataset.wishlistCount - 1;

    if(qtyNew == 0) {
      this.wishlistCount.classList.remove('icon-wishlist-full');
      this.wishlistCountMobile.classList.remove('icon-wishlist-full-mobile');
      this.wishlistCount.classList.add('hidden');
      this.wishlistCountMobile.classList.add('hidden');
    }
    this.wishlistCount.dataset.wishlistCount = qtyNew;
    this.wishlistCountMobile.dataset.wishlistCountMobile = qtyNew;
    if(this.qtyWishlistTitle != null || typeof this.qtyWishlistTitle !== 'undefined') {
      this.qtyWishlistTitle.text(' ('+qtyNew+')');
    }
  }

  bindEvents() {
    let self = this;

    this.$on(this.$customEvents.PRODUCT_EVENTS.addtowish, (e) => {
      let $elem = $(e.payload);
      let url = $elem.data('href');
      this.originalFocus = e.payload;

      $.ajax({
        url:  url,
        data: {
          code: $elem.data('code')
        },
        dataType: "html",
        success: function(resp) {
          self.$emit(self.$customEvents.PRODUCT_EVENTS.addedtowish, $elem);

          if(resp > 0) {
            self.wishlistCount.classList.remove('hidden');
            self.wishlistCountMobile.classList.remove('hidden');
            self.wishlistCount.classList.add('icon-wishlist-full');
            self.wishlistCountMobile.classList.add('icon-wishlist-full-mobile');
          }
          self.wishlistCount.dataset.wishlistCount = resp;
          self.wishlistCountMobile.dataset.wishlistCountMobile = resp;
        },
        error: function(xhr) {
          console.log('error in add to wishlist');
        }
      });
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, (e) => {
      this.updateWishlist().always(res => {
        this.appendHtml(res).then(res => {

          let self = this;
          let $elem = $(e.payload);
          let code = $elem.data('code').toString().substring(0, 13);
          let item = $(`div[data-code="${code}"]`);

          item.addClass(self.CLASSES.removing);
          this.updateQtyWishlist();

          setTimeout(function(){ item.remove() }, 800);

        });
      });
    });

    $('body').off('click.wishlist').on('click.wishlist', self.SELECTORS.remove, function() {
      self.$emit(self.$customEvents.PRODUCT_EVENTS.removefromwish, this)
    });

    this.$on(this.$customEvents.PRODUCT_EVENTS.removefromwish, (e) => {
      this.removeProduct(e.payload);
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
  }
}
